import React from 'react';

function ServiceApproach() {
  return (
    <section className="service-approach-section">
      <div className="container service-approach-container">
        {/* Left Side: Image with Overlapping Info Card */}
        <div className="service-approach-left">
          <div className="image-wrapper">
            <img
              src="/assets/images/service_approach_professional.png"
              alt="Service Approach Professional"
              className="approach-portrait-img"
            />
            {/* Overlapping Info Card at the bottom left */}
            <div className="approach-overlay-card">
              <p>For personalized assistance, schedule a consultation now.</p>
              <a 
                href="/contact/" 
                onClick={(e) => {
                  e.preventDefault();
                  const contactForm = document.querySelector('.contact-section') || document.getElementById('contact-form');
                  if (contactForm) {
                    contactForm.scrollIntoView({ behavior: 'smooth' });
                  } else {
                    window.location.href = '/contact/';
                  }
                }} 
                className="approach-overlay-link"
              >
                <span className="chevron-right">&gt;</span> Contact Us
              </a>
            </div>
          </div>
        </div>

        {/* Right Side: Text, Bullet Points, and Stats */}
        <div className="service-approach-right">
          <div className="approach-tagline-row">
            <span className="approach-tagline">Our Service Approach</span>
            <div className="approach-tagline-line"></div>
          </div>

          <h2 className="approach-title">
            Achieving Excellence Through Strategic Methods
          </h2>

          <p className="approach-description">
            Engage in effortless collaboration with our efficient and impactful service approach. We emphasize effectiveness to not only meet but surpass your objectives. Uncover the strength of a partnership dedicated to working as diligently as you.
          </p>

          {/* Bullet Points */}
          <ul className="approach-bullets">
            <li>
              <span className="bullet-chevron">&gt;</span> Leading the Call Center Revolution.
            </li>
            <li>
              <span className="bullet-chevron">&gt;</span> Tailored Solutions for Businesses, Big and Small.
            </li>
            <li>
              <span className="bullet-chevron">&gt;</span> Navigated by Our Expert Maestros.
            </li>
            <li>
              <span className="bullet-chevron">&gt;</span> Continuous Improvement Through Customer Insights.
            </li>
          </ul>

          {/* Stat Counters Row */}
          <div className="approach-stats-row">
            {/* Stat 1 */}
            <div className="approach-stat-box">
              <div className="stat-icon-wrapper">
                {/* SVG Calendar Star Outline */}
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stat-icon">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                  <polygon points="12 12 13 14 15 14 13.5 15.5 14 17.5 12 16.5 10 17.5 10.5 15.5 9 14.5 11 14.5"></polygon>
                </svg>
              </div>
              <div className="stat-info">
                <span className="stat-number">90+</span>
                <span className="stat-label">Years of Excellence</span>
              </div>
            </div>

            {/* Stat 2 */}
            <div className="approach-stat-box">
              <div className="stat-icon-wrapper">
                {/* SVG Monitor with User / Headset Outline */}
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stat-icon">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                  <path d="M17 12v-1a5 5 0 0 0-10 0v1"></path>
                  <circle cx="12" cy="8" r="2"></circle>
                </svg>
              </div>
              <div className="stat-info">
                <span className="stat-number">75,000+</span>
                <span className="stat-label">Number of Calls Per Day</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceApproach;
